var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"walls"},[_c('div',{staticClass:"walls__left"}),_c('div',{staticClass:"walls__right"}),_c('div',{staticClass:"walls__top"},[_c('img',{staticClass:"walls__sign",attrs:{"src":require("../assets/img/walls-sign.png"),"alt":"Yellow Brick Road - Happy Birthday Elton!"}})])])
}]

export { render, staticRenderFns }